export type CsvColumn<T> = {
  header: string
  accessor: (row: T) => string | number | null | undefined
}

function escapeCsvValue(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return ''
  let str = String(value)
  if (/^[=+\-@]/.test(str)) {
    str = `'${str}`
  }
  if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

export function generateCsv<T>(columns: CsvColumn<T>[], rows: T[]): string {
  const header = columns.map((col) => escapeCsvValue(col.header)).join(',')
  const body = rows.map((row) => columns.map((col) => escapeCsvValue(col.accessor(row))).join(',')).join('\n')
  return `${header}\n${body}`
}

export function downloadCsv(csvContent: string, filename: string): void {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  setTimeout(() => URL.revokeObjectURL(url), 100)
}
